// base is never requested, it only gives the URL parser something to resolve against
const BASE = 'https://internal.invalid';

const hasControlChar = (value: string): boolean =>
  [...value].some(char => {
    const code = char.charCodeAt(0);

    return code < 0x20 || code === 0x7f;
  });

/**
 * True only for a same-site path (`/admin/classes?tab=x`). Resolving through the
 * URL parser is deliberate: browsers treat `/\evil.com` and `/\t/evil.com` as
 * another host, which a plain `startsWith('//')` check lets through. Control
 * characters are refused outright: the parser strips them, but the raw string
 * is what reaches a Location header, where a newline is a 500.
 */
export function isInternalPath(to: unknown): to is string {
  if (typeof to !== 'string' || !to.startsWith('/')) return false;
  if (hasControlChar(to)) return false;

  try {
    return new URL(to, BASE).origin === BASE;
  } catch {
    return false;
  }
}

/** `to` when it is a same-site path, else `fallback`. Guards open redirects. */
export function internalPathOr(to: unknown, fallback: string): string {
  return isInternalPath(to) ? to : fallback;
}
